import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(600px, 1fr));
	gap: 20px;
	justify-content: center;
	width: 100%;
	max-height: 840px;
	margin: 0 auto;
	padding: 0 40px 20px;
	overflow-y: scroll;
	transition: opacity 0.3s ease;

	&::-webkit-scrollbar {
		display: none;
	}

	&.tab-enter {
		opacity: 0;
	}

	&.tab-enter-active,
	&.tab-enter-done,
	&.tab-exit {
		opacity: 1;
	}

	&.tab-exit-active {
		opacity: 0;
	}
`;

const StyledEmptyContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 878px;

	${Text} {
		font-weight: 500;
		font-size: 16px;
		text-align: center;
		color: #ffffff;
		opacity: 0.25;
	}
`;

export { StyledContainer, StyledEmptyContainer };
